module.exports = __webpack_public_path__ + "static/media/usaid.4270606a.png";